// This function returns a subset of headers (received in the request for a server-side-rendered Seeker App page)
// which are forwarded to the Listing API call that is made during the server-side rendering.
// This is done for the anti-crawling purposes: these headers are added at the request of the Cloudflare workers.
export function getPassThroughHeaders(headers: Record<string, string>): Record<string, string> {
  const forwardedHeaderNames: Array<string> = ['user-agent', 'acw-request-properties'];
  return Object.fromEntries(
    Object.entries(headers).filter((entry): entry is [string, string] => {
      const [key, _] = entry;
      return forwardedHeaderNames.includes(key.toLowerCase().trim());
    }),
  );
}
